import { FetchMoreOptions, QueryHookOptions } from "@apollo/client";
import {
  CustomGetCrewsQuery,
  CustomGetCrewsQueryVariables,
  useCustomGetCrewsQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetCrews(
  { first = 10, page = 1, search, sort }: CustomGetCrewsQueryVariables,
  baseOptions: QueryHookOptions<CustomGetCrewsQuery, CustomGetCrewsQueryVariables> = undefined
) {
  const {
    data: graphqlData,
    loading,
    error,
    fetchMore: more,
  } = useCustomGetCrewsQuery({
    variables: { first, page, search, sort },
    ...baseOptions,
  });

  const fetchMore = useCallback(
    async ({
      page,
      updateQuery,
    }: {
      page: number;
      updateQuery?: FetchMoreOptions<
        CustomGetCrewsQuery,
        CustomGetCrewsQueryVariables
      >["updateQuery"];
    }) => {
      return more({
        variables: { page },
        updateQuery,
      });
    },
    [more]
  );

  const data = useMemo(() => graphqlData?.getCrews?.data ?? null, [graphqlData]);
  const paginatorInfo = useMemo(() => graphqlData?.getCrews?.paginatorInfo ?? null, [graphqlData]);

  return { data, loading, error, paginatorInfo, fetchMore } as const;
}
